import { useState } from 'react';
import { Box, Collapse, Link, Stack, type SxProps, type Theme } from '@mui/material';
import { CollapsibleSectionHeader } from './CollapsibleSectionHeader';
import type { DocumentCitation } from '../../core/types/data-models';

/**
 * The web sources a piece of generated content drew on, listed under a
 * "Sources (n)" header that starts collapsed. Renders nothing without sources.
 */
export function SourcesBlock({
  sources,
  sx,
}: {
  sources: DocumentCitation[] | null | undefined;
  sx?: SxProps<Theme>;
}) {
  const [open, setOpen] = useState(false);
  if (!sources || sources.length === 0) return null;
  return (
    <Box sx={sx}>
      <CollapsibleSectionHeader
        title="Sources"
        count={sources.length}
        expanded={open}
        onToggle={() => setOpen((v) => !v)}
      />
      <Collapse in={open}>
        <Stack spacing={0.5} sx={{ mt: 0.5 }}>
          {sources.map((s, i) => (
            <Link
              key={`${s.url}-${i}`}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              variant="caption"
              sx={{ display: 'block' }}
            >
              {s.title || s.url}
            </Link>
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
}
